module.exports = __webpack_public_path__ + "static/img/ic_telegram.5696bb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/ic_telegram.png
// module id = OSVH
// module chunks = 0